/**
 * Typed accessors for comment enum fields.
 *
 * The generated swagger SDK declares its enum members as `<any> 'VALUE'`, so
 * the static type of `comment.status` / `comment.targetType` cannot be narrowed
 * even though the runtime value is always the literal string. These accessors
 * isolate the single unavoidable `String(...)` coercion behind a typed surface
 * so call sites stay free of `as unknown as string` casts.
 */

export const COMMENT_STATUS = {
  OPEN: "OPEN",
  RESOLVED: "RESOLVED",
} as const;
export type CommentStatus =
  (typeof COMMENT_STATUS)[keyof typeof COMMENT_STATUS];

export const COMMENT_TARGET = {
  FLYER: "FLYER",
  FLYER_ITEM: "FLYER_ITEM",
  FIELD: "FIELD",
} as const;
export type CommentTarget =
  (typeof COMMENT_TARGET)[keyof typeof COMMENT_TARGET];

/** Runtime status string of a comment ("" when absent). */
export const commentStatusOf = (c: { status?: unknown }): string =>
  c.status == null ? "" : String(c.status);

/** Runtime target-type string of a comment ("" when absent). */
export const commentTargetOf = (c: { targetType?: unknown }): string =>
  c.targetType == null ? "" : String(c.targetType);

export const isOpenComment = (c: { status?: unknown }): boolean =>
  commentStatusOf(c) === COMMENT_STATUS.OPEN;

export const isResolvedComment = (c: { status?: unknown }): boolean =>
  commentStatusOf(c) === COMMENT_STATUS.RESOLVED;
